var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturetime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blurFilter",
    x: -10,
    y: -10,
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#blurFilter)",
    stroke: "blue",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 7,
    x2: 14,
    y2: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 18,
    height: 6,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 17,
    x2: 10,
    y2: 17
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturetime);
export default __webpack_public_path__ + "static/media/featuretime.98623f3c08cc6a150582dc3c2482f88a.svg";
export { ForwardRef as ReactComponent };